import script from "./icon-check.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-check.vue?vue&type=script&lang=ts&setup=true"

import "./icon-check.vue?vue&type=style&index=0&id=07875e90&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07875e90"]])

export default __exports__